import RestClient from '../../../../../api/axiosInterceptor';
import { patientProfileCompletionActions } from '../../../../actions/user/patient/auth/profile_completion_status';

/**
 * Checks profile completion status
 * @param {string} credentials - Base64 encoded credentials or token
 * @param {function} toastCallback - Optional callback for showing toasts (intent, message)
 * @returns {function} Redux thunk function
 */
export const checkPatientProfileCompletion =
	(credentials, toastCallback = null) =>
	  async (dispatch) => {
	    dispatch({
	      type: patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.REQUEST
	    });

	    try {
	      const response = await RestClient.get(
	        '/patient/profile/check-completion/',
	        {
	          headers: {
	            Authorization: `Basic ${credentials}`,
	            'Content-Type': 'application/json'
	          }
	        }
	      );

	      const isComplete = response.status === 200;
	      const incompleteFields = isComplete
	        ? []
	        : response.data?.incomplete_fields || [];

	      const result = {
	        isComplete,
	        incompleteFields,
	        lastChecked: new Date().toISOString()
	      };

	      dispatch({
	        type: patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.SUCCESS,
	        payload: result
	      });

	      return {
	        success: true,
	        ...result
	      };
	    } catch (error) {
	      const errorMessage =
				error.response?.data?.message || 'Failed to check profile completion';

	      dispatch({
	        type: patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.FAILURE,
	        payload: errorMessage
	      });

	      if (toastCallback) {
	        toastCallback('error', errorMessage);
	      }

	      console.error('Profile completion check error:', error);

	      return {
	        success: false,
	        isComplete: false,
	        incompleteFields: [],
	        error: errorMessage
	      };
	    }
	  };
